import { createSelector } from 'reselect';

const selectReferrerSettings = (state) => state.get('referrerSettings');

export const makeSelectSaving = () =>
	createSelector(selectReferrerSettings, (sub) =>
		sub ? sub.get('saving') : false
	);

export const makeSelectSaved = () =>
	createSelector(selectReferrerSettings, (sub) =>
		sub ? sub.get('saved') : false
	);

export const makeSelectLoading = () =>
	createSelector(selectReferrerSettings, (sub) =>
		sub ? sub.get('loading') : false
	);

export const makeSelectNotifyEmail = () =>
	createSelector(selectReferrerSettings, (sub) =>
		sub ? sub.get('notifyEmail') : true
	);

export const makeSelectNotifySms = () =>
	createSelector(selectReferrerSettings, (sub) =>
		sub ? sub.get('notifySms') : false
	);
